import Smartphones from 'Reports/views/AnnualReport/AnnualReportsView/containers/Smartphones'
import Tablets from 'Reports/views/AnnualReport/AnnualReportsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const AnnualReportsView = getCurrentDeviceView(Smartphones, Tablets)

export default AnnualReportsView
